<!--
文档访问统计
@author 姚润发
@created 2021/02/02 9:53
-->
<template>
    <div>

		<lnk-panelfolder title="最近一年内访问统计">
			<el-row>
				<el-col :span="6" class="access-count-wrapper">
					<div class="access-count-title">
						<h4>今天访问量</h4>
						<span class="access-count-title__right">{{accessTodayList.reduce((total, item) => total + Number(item.today), 0)}}</span>
					</div>
					<hr>
					<p v-for="item in accessTodayList" class="access-count-item" @click="openUserMenu(item.firstName)">
						{{item.firstName}}
						<span class="access-count-item__right">{{item.today}}</span>
					</p>
				</el-col>
				<el-col :span="6" class="access-count-wrapper">
					<div class="access-count-title">
						<h4>7天内访问量</h4>
						<span class="access-count-title__right">{{accessWeekList.reduce((total, item) => total + Number(item.week), 0)}}</span>
					</div>
					<hr>
					<p v-for="item in accessWeekList" class="access-count-item" @click="openUserMenu(item.firstName)">
						{{item.firstName}}
						<span class="access-count-item__right">{{item.week}}</span>
					</p>
				</el-col>
				<el-col :span="6" class="access-count-wrapper">
					<div class="access-count-title">
						<h4>30天内访问量</h4>
						<span class="access-count-title__right">{{accessMonthList.reduce((total, item) => total + Number(item.month), 0)}}</span>
					</div>
					<hr>
					<p v-for="item in accessMonthList" class="access-count-item" @click="openUserMenu(item.firstName)">
						{{item.firstName}}
						<span class="access-count-item__right">{{item.month}}</span>
					</p>
				</el-col>
				<el-col :span="6" class="access-count-wrapper">
					<div class="access-count-title">
						<h4>一年内访问量</h4>
						<span class="access-count-title__right">{{accessYearList.reduce((total, item) => total + Number(item.year), 0)}}</span>
					</div>
					<hr>
					<p v-for="item in accessYearList" class="access-count-item" @click="openUserMenu(item.firstName)">
						{{item.firstName}}
						<span class="access-count-item__right">{{item.year}}</span>
					</p>
				</el-col>
			</el-row>
		</lnk-panelfolder>

	</div>
</template>

<script>

  export default {
    name: "access-statistics",
    data() {
      return {
		accessList: [],
	  }
    },
	computed: {
      accessTodayList() {
        const list = linkTools.deepCopy(this.accessList).filter(item => item.today > 0);
        return list.sort((a, b) => b.today - a.today)
	  },
      accessWeekList() {
        const list = linkTools.deepCopy(this.accessList).filter(item => item.week > 0);
        return list.sort((a, b) => b.week - a.week)
	  },
      accessMonthList() {
        const list = linkTools.deepCopy(this.accessList).filter(item => item.month > 0);
        return list.sort((a, b) => b.month - a.month)
	  },
      accessYearList() {
        const list = linkTools.deepCopy(this.accessList).filter(item => item.year > 0);
        return list.sort((a, b) => b.year - a.year);

	  }
	},
	methods: {
      openUserMenu(name) {
        this.$nav.openTab({
          id: `${name}doc-components/page/my-menu.vue`,
          title: `${name}的文档`,
          path: 'my-menu',
          param: {
            onlyMyDocFlag: true,
			fstName: name,
          }
        });
	  }
	},
	async created() {
      // this.createOption.list = this.$lv.$documentAccessService.countPageByAuthor();
      const list = await this.$lv.$documentAccessService.sumAccess(this);
      this.accessList = list.map(item => {
        return {
          ...item,
          year: Number(item.year),
          month: Number(item.month),
          week: Number(item.week),
          today: Number(item.today)
		}
	  }).filter(item => !!item.firstName);
    }
  }
</script>

<style scoped lang="scss">
	@import './statistics';
</style>
